import { render, staticRenderFns } from "./FrameworkEdit.vue?vue&type=template&id=9d5ef60e"
import script from "./FrameworkEdit.vue?vue&type=script&lang=js"
export * from "./FrameworkEdit.vue?vue&type=script&lang=js"
import style0 from "./FrameworkEdit.vue?vue&type=style&index=0&id=9d5ef60e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports